/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailabilityDto
 */
export interface AvailabilityDto {
    /**
     * 
     * @type {number}
     * @memberof AvailabilityDto
     */
    idavailability?: number;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityDto
     */
    label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityDto
     */
    code?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AvailabilityDto
     */
    defaultAvailability?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityDto
     */
    startTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityDto
     */
    endTime?: string | null;
}

/**
 * Check if a given object implements the AvailabilityDto interface.
 */
export function instanceOfAvailabilityDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AvailabilityDtoFromJSON(json: any): AvailabilityDto {
    return AvailabilityDtoFromJSONTyped(json, false);
}

export function AvailabilityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailabilityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idavailability': !exists(json, 'idavailability') ? undefined : json['idavailability'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'defaultAvailability': !exists(json, 'defaultAvailability') ? undefined : json['defaultAvailability'],
        'startTime': !exists(json, 'startTime') ? undefined : json['startTime'],
        'endTime': !exists(json, 'endTime') ? undefined : json['endTime'],
    };
}

export function AvailabilityDtoToJSON(value?: AvailabilityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idavailability': value.idavailability,
        'label': value.label,
        'code': value.code,
        'defaultAvailability': value.defaultAvailability,
        'startTime': value.startTime,
        'endTime': value.endTime,
    };
}

